import type { ReactNode } from "react";

type Props = {
  label: string;
  icon: string;
  expanded: boolean;
  forceExpand?: boolean;
  onToggle: () => void;
  children: ReactNode;
};

export function FallbackToggle({ label, icon, expanded, forceExpand, onToggle, children }: Props) {
  const showChildren = forceExpand || expanded;

  if (forceExpand) {
    return <div data-fallback-toggle="forced">{children}</div>;
  }

  if (showChildren) {
    return (
      <div data-fallback-toggle="open" className="flex flex-col gap-2">
        {children}
        {/* 直上に必ず interactive な要素が来るので、当たり判定は負 margin で上へ広げず
            実寸 44px (Apple HIG) で確保する。gap も 4px → 8px に広げる (Material の 8dp):
            resume-prompt では直上が「最初から」= 確認なしの全回答消去で、4px しか離れて
            いないと「⌃ 閉じる」を狙った指が全消去を踏む。指の接触幅 (40〜53 CSS px) に
            対して 4px の分離は無いに等しい。
            文字は下の閉じている側と同じ 13px — 同じ component の表と裏で大きさが違うと、
            開く前と後で文字が縮んだように見える。 */}
        <button
          type="button"
          onClick={onToggle}
          aria-label={`${label} を閉じる`}
          className="self-start inline-flex items-center min-h-[44px] px-3 text-[13px] text-slate-500 hover:text-slate-700 hover:underline"
        >
          ⌃ 閉じる
        </button>
      </div>
    );
  }

  return (
    // 4 箇所から使われる共有 component で周囲の余白が呼び出し元ごとに違うため、
    // 負 margin は焼き込まず実寸 44px (Apple HIG) で確保する (相殺は呼び出し元の責務)。
    // 文字は 13px (HIG の Footnote 相当)。**ここは原則 5 の fallback の入口**なので、
    // 音声で詰まった人が最初に探す導線が読めないのは本末転倒 — 11px (Caption 2 = 注釈の
    // 下限) では小さすぎる。一次動線との差は「塗りつぶさない・下線のみ」で表現する。
    <button
      type="button"
      onClick={onToggle}
      data-fallback-toggle="closed"
      className="self-start inline-flex items-center min-h-[44px] px-3 text-[13px] text-indigo-600 hover:text-indigo-800 hover:underline"
    >
      {icon} {label}
    </button>
  );
}
